const formatEWSkh = (value) => {
	if (value) {
		return value?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	} else return null;
};

export default formatEWSkh;
